'use strict';

const $ = jQuery.noConflict();

$(function() {
	const team = {
		init: function() {
			this.cacheDOM();
			if (!this.$component.length) {
				return;
			}
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$component = $('.js-team');
			this.$grid = this.$component.find('.js-team-grid');
			this.$items = this.$component.find('.js-team-item');
			this.$cards = this.$component.find('.js-team-card');
			this.$panels = this.$component.find('.js-team-panel');
		},

		bindEvents: function() {
			this.$cards.on('click', this.onCardClick.bind(this));
			this.$panels.on('click', this.onPanelClick.bind(this));
			$(window).on('resize.team', this.debounce(this.onResize.bind(this), 200));
			$(document).on('keydown.team', this.onKeyDown.bind(this));
		},

		debounce: function(fn, wait) {
			let timeout;
			return function() {
				clearTimeout(timeout);
				timeout = setTimeout(fn, wait);
			};
		},

		onCardClick: function(e) {
			const $item = $(e.currentTarget).closest('.js-team-item');
			const isActive = $item.hasClass('is-active');
			const $row = this.getRow($item);

			this.closeRow($row);

			if (!isActive) {
				this.openItem($item, $row);
			}
		},

		onPanelClick: function(e) {
			const $panel = $(e.currentTarget);

			if (!$panel.hasClass('is-covering-self')) {
				return;
			}

			const $item = this.getItemFor($panel);

			if (!$item.length) {
				return;
			}

			this.closeRow(this.getRow($item));
		},

		onKeyDown: function(e) {
			if (e.key === 'Escape') {
				this.closeAll();
			}
		},

		onResize: function() {
			this.closeAll();
		},

		getRow: function($item) {
			const top = Math.round($item[0].getBoundingClientRect().top);

			return this.$items.filter(function() {
				return Math.round(this.getBoundingClientRect().top) === top;
			});
		},

		getPanelFor: function($item) {
			const index = $item.data('team-index');

			return this.$panels.filter(function() {
				return $(this).data('team-index') === index;
			});
		},

		getItemFor: function($panel) {
			const index = $panel.data('team-index');

			return this.$items.filter(function() {
				return $(this).data('team-index') === index;
			});
		},

		openItem: function($item, $row) {
			const $panel = this.getPanelFor($item);

			if (!$panel.length) {
				return;
			}

			this.cancelPanelCollapse($panel);

			$item.addClass('is-active');

			const $card = $item.find('.js-team-card');

			$card.attr('aria-expanded', 'true');

			$row.not($item).addClass('is-covered');
			$row.not($item).find('.js-team-card').attr('tabindex', '-1');

			const itemRect = $item[0].getBoundingClientRect();
			const cardRect = $card[0].getBoundingClientRect();
			const gridRect = this.$grid[0].getBoundingClientRect();
			const columnsPerRow = Math.max(1, Math.round(gridRect.width / itemRect.width));

			if (columnsPerRow < 2) {
				$panel.addClass('is-covering-self is-open').attr('aria-hidden', 'false').css({
					left: (cardRect.left - gridRect.left) + 'px',
					top: (cardRect.bottom - gridRect.top + 16) + 'px',
					width: cardRect.width + 'px',
					height: cardRect.height + 'px',
				});

				return;
			}

			// .team__item carries horizontal padding that the grid's matching
			// negative margin absorbs at the row edges; the covered rect needs
			// to line up with the visible card, not the padded item box.
			const itemPadding = parseFloat(getComputedStyle($item[0]).paddingLeft) || 0;
			const colIndex = Math.round((itemRect.left - gridRect.left) / itemRect.width);
			const isLastColumn = colIndex === columnsPerRow - 1;
			const width = (gridRect.width - itemRect.width) - (itemPadding * 2);
			let left = itemRect.width + itemPadding;

			if (isLastColumn) {
				left = itemPadding;
			} else if (colIndex !== 0) {
				const deltaX = gridRect.left - itemRect.left;
				$item.addClass('is-sliding').css('transform', 'translateX(' + deltaX + 'px)');
			}

			$panel.removeClass('is-covering-self').css({
				left: left + 'px',
				top: (cardRect.top - gridRect.top) + 'px',
				width: width + 'px',
				height: cardRect.height + 'px',
			}).addClass('is-open').attr('aria-hidden', 'false');
		},

		closeRow: function($row) {
			if (!$row.length) {
				return;
			}

			$row.removeClass('is-active is-covered is-sliding').css('transform', '');
			$row.find('.js-team-card').attr('aria-expanded', 'false').removeAttr('tabindex');

			const indices = $row.map(function() {
				return $(this).data('team-index');
			}).get();

			const $panels = this.$panels.filter(function() {
				return indices.indexOf($(this).data('team-index')) !== -1;
			});

			$panels.removeClass('is-open').attr('aria-hidden', 'true');
			$panels.each(this.schedulePanelCollapse.bind(this));
		},

		schedulePanelCollapse: function(index, panel) {
			const $panel = $(panel);

			this.cancelPanelCollapse($panel);

			const timer = setTimeout(function() {
				if (!$panel.hasClass('is-open')) {
					$panel.removeClass('is-covering-self').css({
						left: '',
						top: '',
						width: '',
						height: '',
					});
				}

				$panel.removeData('collapseTimer');
			}, this.getTransitionDuration($panel));

			$panel.data('collapseTimer', timer);
		},

		cancelPanelCollapse: function($panel) {
			const existingTimer = $panel.data('collapseTimer');

			if (existingTimer) {
				clearTimeout(existingTimer);
				$panel.removeData('collapseTimer');
			}
		},

		getTransitionDuration: function($el) {
			const value = ($el.css('transition-duration') || '0s').split(',')[0];
			const seconds = parseFloat(value);

			return (isNaN(seconds) ? 0 : seconds) * 1000;
		},

		closeAll: function() {
			this.closeRow(this.$items);
		},
	};

	team.init();
});
